import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SEO from "../SEO";
import config from "../../config";
import api, { baseURL } from "../../utils/api";
import { useFocusAgent } from "./TheSeaLayout";
import { useTheSeaContext } from "./TheSeaContext";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function PointPurchaseSucceeded() {
  const query = useQuery();
  const navigate = useNavigate();
  const focusAgent = useFocusAgent();
  const { setPointsBalance } = useTheSeaContext();
  const sessionId = query.get("session_id");

  const [loading, setLoading] = useState(true);
  const [purchase, setPurchase] = useState(null);

  useEffect(() => {
    const load = async () => {
      if (!sessionId) {
        setLoading(false);
        return;
      }

      try {
        // get_by_session synchronously confirms payment with Stripe and credits the balance if
        // needed (see GetPointPurchaseBySession on the backend), so it must resolve before we
        // fetch the balance below - otherwise we could read the balance before the credit lands.
        const purchaseRes = await api.get(`${baseURL}/authenticated/point/get_by_session?session_id=${sessionId}`);
        setPurchase(purchaseRes.data || null);

        const balanceRes = await api.get(`${baseURL}/authenticated/point/balance`);
        setPointsBalance(balanceRes.data?.balance ?? 0);
      } catch (err) {
        console.error("Failed to fetch point purchase:", err);
      } finally {
        setLoading(false);
      }
    };

    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  const goToChat = () => {
    navigate("/");
    focusAgent();
  };

  return (
    <>
      <SEO
        title="Points Added — askTheSea"
        description="Your point purchase was successful."
        url={`${config.BaseUrl}/points/succeeded`}
        image={`${config.BaseUrl}/assets/logo.png?v=2`}
        noindex
      />
      <section className="page active" id="page-points-succeeded">
        <div className="wrap" style={{ paddingTop: "60px" }}>
          <div className="purchase-result">
            {loading ? (
              <p>Loading…</p>
            ) : !purchase ? (
              <>
                <div className="result-icon">⚠️</div>
                <h1>Purchase information not found</h1>
                <button type="button" className="btn btn-primary" onClick={goToChat}>Go to chat</button>
              </>
            ) : (
              <>
                <div className="result-icon">🎉</div>
                <h1>Points added</h1>
                <p className="result-detail">
                  {purchase.points} point{purchase.points === 1 ? "" : "s"} added to your account.
                </p>
                <button type="button" className="btn btn-primary" onClick={goToChat}>Keep chatting</button>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
